import { Prompt } from "@/types/app/prompt";
import { FileLabelWithPopover } from "@components/library/Entities/FileLabelWithPopover";
import { PageSectionHeader } from "@components/library/PageSectionHeader";
import { JSONViewer } from "@components/llama/Code/JSONViewer";
import { ToolFunctionWithPopover } from "@components/PromptEditor/Tools/ToolFunctionWithPopover";
import { isEmpty, startCase } from "lodash";

export type ToolDetailsProps = Pick<Prompt, "tools">;

export const ToolDetails = ({ tools }: ToolDetailsProps) => {
  if (isEmpty(tools)) {
    return null;
  }

  return (
    <div className="mt-24">
      <PageSectionHeader title={"Tools"} size="sm" />
      <div className={"flex flex-col gap-6"}>
        {tools?.map((tool, index) => {
          switch (tool.type) {
            case "inline":
              return (
                <div key={index} className="rounded border border-oldgray-400 bg-oldgray-200 px-8 py-8 text-11-16">
                  <div className="px-4 py-4 text-12-14 font-bold text-oldgray-600">
                    {startCase(tool.json_schema.name)}
                  </div>
                  <div key={index} className="text-12-14">
                    <JSONViewer
                      value={{
                        name: tool.json_schema.name,
                        description: tool.json_schema.description,
                        parameters: tool.json_schema.parameters,
                      }}
                      defaultInspectDepth={0}
                    />
                  </div>
                </div>
              );
            case "file":
              return (
                <div key={index} className="">
                  <FileLabelWithPopover
                    fileId={tool.link.file_id}
                    displayFile
                    size={20}
                    versionId={tool.file?.version_id}
                  />
                </div>
              );
          }
        })}
      </div>
    </div>
  );
};

export const ToolDetailsSmall = ({ tools }: ToolDetailsProps) => {
  if (isEmpty(tools)) {
    return null;
  }

  return (
    <div className={"flex flex-wrap gap-8 text-10-12"}>
      {tools?.map((tool, index) => {
        switch (tool.type) {
          case "inline":
            return (
              <div key={`inline-tool-${index}`}>
                <ToolFunctionWithPopover key={tool.json_schema.name} toolFunction={tool.json_schema} size={18} />
              </div>
            );
          case "file":
            return (
              <div key={`file-tool-${index}`}>
                <FileLabelWithPopover
                  fileId={tool.link.file_id}
                  displayFile
                  size={18}
                  versionId={tool.file.version_id}
                />
              </div>
            );
        }
      })}
    </div>
  );
};
